import { useBackend } from "../../services";

export const useDeleteAlbumIdentifier = () => {
  const { deleteRequest } = useBackend();
  const deleteAlbumIdentifier = (parameters: IDeleteAlbumIdentifierParameters) =>
    deleteRequest("albumIdentifiers", parameters);
  return { deleteAlbumIdentifier };
};

export interface IDeleteAlbumIdentifierParameters {
  uuid: string;
}
